export default __webpack_public_path__ + "static/media/hand-phone.27985a89.svg";